import { render, staticRenderFns } from "./AlbumDownloadProgressDialog.vue?vue&type=template&id=0a5dcd34"
import script from "./AlbumDownloadProgressDialog.vue?vue&type=script&lang=js"
export * from "./AlbumDownloadProgressDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a5dcd34')) {
      api.createRecord('0a5dcd34', component.options)
    } else {
      api.reload('0a5dcd34', component.options)
    }
    module.hot.accept("./AlbumDownloadProgressDialog.vue?vue&type=template&id=0a5dcd34", function () {
      api.rerender('0a5dcd34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/album/components/AlbumDownloadProgressDialog.vue"
export default component.exports